import $ from 'jquery';
import { initTooltips } from '@/js/modules/tooltips';
import { isMobile } from '@/js/modules/viewport';
import {
  deleteMessage,
  divideMessagesContainerByDate,
  filterMessageByThread,
  resetMessageInputs,
  toggleMessageAuthorClass,
  validateMessageBeforeShow,
} from '@/js/modules/discussion_messages';
import { onPageLoad } from '@/js/modules/page_load';
import '@/js/modules/jquery_modal_defaults';

let $discussionPanel;
let $mainContainer;
let panelProjectId;
let pageUserRole;
let firstTimeTabToggle;

// The legacy 990px column slides sideways so the fixed panel doesn't cover it. Full-width
// pages (boards#show v2) render the opt-out marker instead and stay put.
function shouldOffsetMainForDiscussionPanel() {
  return !document.querySelector('[data-discussion-panel-no-offset]');
}

export function toggleDiscussionPanel(
  forceState = null,
  onReady = null,
  skipScroll = null,
  autoFocus = null,
  refreshContent = null
) {
  const forceOpen = forceState === true;
  const forceClosed = forceState === false;
  const $messagesContainer = $discussionPanel.find('.discussion-panel__messages-container');

  if (!onReady) {
    $discussionPanel.addClass('discussion-panel--with-anim');
  }

  const offsetMain = shouldOffsetMainForDiscussionPanel();

  if (forceOpen || forceClosed) {
    $discussionPanel.toggleClass('discussion-panel--active', forceOpen);
    if (offsetMain) {
      $mainContainer.toggleClass('main--with-discussion-panel', forceOpen);
    }
  } else {
    $discussionPanel.toggleClass('discussion-panel--active');
    if (offsetMain) {
      $mainContainer.toggleClass('main--with-discussion-panel');
    }
  }

  const isPanelActive = $discussionPanel.hasClass('discussion-panel--active');
  setDiscussionPanelOpenStatus(isPanelActive);

  if (isPanelActive) {
    $discussionPanel.get(0).dispatchEvent(new CustomEvent('messages:open'));

    if (refreshContent) {
      $messagesContainer.each(function () {
        loadMoreMessages($(this), null, true);
      });
    }

    $('.action-badge__unread-indicator').remove();
  }

  if (!skipScroll) {
    scrollToMessagesContainerEnd($messagesContainer);
  }

  if (
    autoFocus &&
    !$discussionPanel
      .find('.discussion-panel__messages-container--active .discussion-panel__empty')
      .hasClass('hide')
  ) {
    $discussionPanel.find('.tiptap').focus();
  }

  $('.discussion-panel__header-alert, [data-discussion-panel-unread]').addClass('hide').html(0);
  const $panelHeader = $discussionPanel.find('.discussion-panel__header');

  if ($panelHeader.hasClass('tooltip')) {
    $panelHeader.removeClass('tooltip');
    initTooltips($panelHeader);
    updateDiscussionTooltipReadStatus();
  }

  setTimeout(() => {
    $discussionPanel.removeClass('discussion-panel--with-anim');
  }, 150); // Transition animation time set in messages CSS + buffer

  updateDiscussionPanelContentHeight();
  calcMainContainerPadding();
}

function getDiscussionItemOrInitialize() {
  let discussionItem;
  try {
    discussionItem = JSON.parse(localStorage.getItem('discussionPanel')) || {
      status: 'open',
      projectId: panelProjectId,
      thread: {},
    };
  } catch (e) {
    discussionItem = { status: 'open', projectId: panelProjectId, thread: {} };
  }

  return discussionItem;
}

function setDiscussionPanelOpenStatus(open = true) {
  const discussionItem = getDiscussionItemOrInitialize();
  discussionItem.status = open ? 'open' : 'closed';
  localStorage.setItem('discussionPanel', JSON.stringify(discussionItem));
}

function setDiscussionLocalStorage(name, value) {
  const discussionItem = getDiscussionItemOrInitialize();
  cleanDiscussionKeys(discussionItem);

  if (discussionItem.projectId !== panelProjectId) {
    discussionItem.projectId = panelProjectId;
    discussionItem.thread = {};
  } else if (!discussionItem.thread) {
    discussionItem.thread = {};
  }

  discussionItem.thread[name] = value;

  localStorage.setItem('discussionPanel', JSON.stringify(discussionItem));
}

function getDiscussionLocalStorageItem(name) {
  let discussionItem = localStorage.getItem('discussionPanel');
  if (discussionItem) {
    discussionItem = JSON.parse(discussionItem);
  } else {
    discussionItem = {};
  }

  if (name === 'status') {
    return discussionItem.status || null;
  }

  if (discussionItem.thread && discussionItem.projectId === panelProjectId) {
    return discussionItem.thread[name];
  }
}

function cleanDiscussionKeys(discussionItem) {
  Object.keys(discussionItem).forEach((key) => {
    if (key !== 'status' && key !== 'thread' && key !== 'projectId') {
      delete discussionItem[key];
    }
  });
}

function removeDiscussionLocalStorageProject() {
  const storedData = localStorage.getItem('discussionPanel');

  if (storedData) {
    const parsedData = JSON.parse(storedData);

    if (parsedData.projectId && parsedData.projectId !== panelProjectId) {
      return;
    }

    delete parsedData.projectId;
    delete parsedData.thread;
    localStorage.setItem('discussionPanel', JSON.stringify(parsedData));
  }
}

function checkAndResetDiscussionLocalStorage() {
  const discussionItem = getDiscussionItemOrInitialize();
  if (discussionItem.projectId && discussionItem.projectId !== panelProjectId) {
    discussionItem.projectId = panelProjectId;
    discussionItem.thread = {};
    localStorage.setItem('discussionPanel', JSON.stringify(discussionItem));
  }
}

function getDiscussionUrlParam(name) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name);
}

function toggleDiscussionTab(selectedTab) {
  const $activeTab = $discussionPanel.find(`[data-discussions-tab="${selectedTab}"]`);
  const $messagesContainer = $discussionPanel.find(
    `[data-discussions-tab-messages="${selectedTab}"]`
  );

  $discussionPanel.find('.discussion-panel__tab').removeClass('discussion-panel__tab--active');
  $discussionPanel
    .find('.discussion-panel__messages-container')
    .removeClass('discussion-panel__messages-container--active');
  $activeTab.addClass('discussion-panel__tab--active');
  $messagesContainer.addClass('discussion-panel__messages-container--active');
  $discussionPanel.find('#discussion_kind').val(selectedTab);
  $('.discussion-panel__text-editor-container')
    .removeClass('text-editor--client text-editor--team')
    .addClass(`text-editor--${selectedTab}`);
  $discussionPanel
    .find('.discussion-panel__form-controls-container')
    .removeClass(
      'discussion-panel__form-controls-container--client discussion-panel__form-controls-container--team'
    )
    .addClass(`discussion-panel__form-controls-container--${selectedTab}`);
  $discussionPanel
    .find('.file-uploader-drop')
    .removeClass('file-uploader-drop--discussion-client file-uploader-drop--discussion-team')
    .addClass(`file-uploader-drop--discussion-${selectedTab}`);
  $discussionPanel
    .find('.discussion-panel__recipients')
    .removeClass('discussion-panel__recipients--client discussion-panel__recipients--team')
    .addClass(`discussion-panel__recipients--${selectedTab}`);
  updateDiscussionPanelContentHeight();
  const $formContainer = $discussionPanel.find('#discussion-panel-form-container');
  if ($formContainer.data('hideWithoutClient') === true) {
    $formContainer.toggleClass('hide', selectedTab === 'client');
  }
  toggleBoardThreadStatus();
  loadMoreMessages($messagesContainer, null, true);

  if (firstTimeTabToggle === true) {
    scrollToMessagesContainerEnd($messagesContainer);
    firstTimeTabToggle = false;
  }
}

function toggleBoardThreadStatus() {
  const $formBoardToggle = $discussionPanel.find('.discussion-panel__form-board-container');

  if ($formBoardToggle.length) {
    const $label = $formBoardToggle.find('.discussion-panel__form-board-toggle');
    const isBoardPublished = $formBoardToggle.attr('data-page-board-published') === 'true';
    const $checkbox = $label.find('input[type="checkbox"]');
    const discussionsTab = $discussionPanel
      .find('.discussion-panel__tab--active')
      .data('discussions-tab');

    if ($discussionPanel.is('.discussion-panel--board, .discussion-panel--shoppable')) {
      $checkbox.prop('disabled', false).prop('checked', true);
      return;
    }

    const toggleBoardRefState = (disabled) => {
      $checkbox.prop('disabled', disabled).prop('checked', !disabled);
      $label.toggleClass('discussion-panel__form-board-toggle--disabled tooltip', disabled);
      initTooltips($label);
    };

    if (discussionsTab === 'team') {
      if ($checkbox.prop('disabled')) {
        toggleBoardRefState(false);
      }
    } else if (discussionsTab === 'client') {
      toggleBoardRefState(!isBoardPublished);
    }
  }
}

function toggleBoardThreadDraftMode(boardThread, boardId, boardPublished) {
  const $boardHeader = $discussionPanel.find('.discussion-panel__thread-container');

  if (!$discussionPanel.is('.discussion-panel--board, .discussion-panel--shoppable')) {
    const panelBoardThread = $discussionPanel.data('boardThread');
    const panelBoardId = $discussionPanel.data('boardId');

    if (panelBoardThread === boardThread && panelBoardId === boardId) {
      const $formContainer = $discussionPanel.find('.discussion-panel__form-container');
      const $fileDropContainer = $discussionPanel.find('.file-uploader-drop');
      if (boardPublished === false) {
        if (!$boardHeader.find('.discussion-panel__board-draft').length) {
          $boardHeader
            .find('.discussion-panel__board-name')
            .append('<span class="discussion-panel__board-draft">Draft</span>');
        }
        $formContainer.addClass('discussion-panel__form-container--draft');
        $fileDropContainer.addClass('file-uploader-drop--discussion-draft');
      } else {
        $boardHeader.find('.discussion-panel__board-draft').remove();
        $formContainer.removeClass('discussion-panel__form-container--draft');
        $fileDropContainer.removeClass('file-uploader-drop--discussion-draft');
      }
    }
  }
}

/**
 * Reads the board image reference off a discussion message.
 *
 * Prefers `data-board-image` (a plain, resolved URL) and falls back to the message's
 * own `<template>` clone when the design's image isn't resolved yet.
 *
 * @param {Object} $discussionMessage
 * @return {String|HTMLTemplateElement|undefined}
 */

function messageBoardImage($discussionMessage) {
  return (
    $discussionMessage.data('board-image') ||
    $discussionMessage.find('[data-board-image-template]').get(0)
  );
}

/**
 * Extracts a plain, persistable image URL from a board-image reference, for localStorage.
 *
 * @param {String|HTMLTemplateElement} boardImage
 * @return {String} image URI or a blank string
 */

function persistableBoardImage(boardImage) {
  if (typeof boardImage === 'string') {
    return boardImage;
  }

  if (boardImage instanceof HTMLTemplateElement) {
    const figure = boardImage.content.querySelector('.designs--thumbnail');
    if (figure && !figure.hasAttribute('data-controller')) {
      return figure.querySelector('img')?.getAttribute('src') ?? '';
    }
  }

  return '';
}

/**
 * Adds a board image to header.
 *
 * @param {Object} $boardHeader
 * @param {String|HTMLTemplateElement} boardImage plain URI string or a template element holding a thumbnail
 */

function setBoardImage($boardHeader, boardImage) {
  const $container = $boardHeader.find('.discussion-panel__board-image-container');
  $container.children('.discussion-panel__board-image').remove();

  if (boardImage instanceof HTMLTemplateElement) {
    $container.append(boardImage.content.cloneNode(true));
  } else if (boardImage) {
    $container.append($('<img>', { class: 'discussion-panel__board-image', src: boardImage }));
  }
}

function enableBoardThreadView(
  boardThread,
  boardId,
  boardName,
  boardImage,
  boardUrl,
  boardPublished,
  messageId = null
) {
  const $boardHeader = $discussionPanel.find('.discussion-panel__thread-container');
  const $messagesContainers = $discussionPanel.find('.discussion-panel__messages-container');
  const boardDetails = {
    'board-thread': boardThread,
    'board-id': boardId,
    'board-name': boardName,
    'board-image': persistableBoardImage(boardImage),
    'board-url': boardUrl,
    'board-published': boardPublished,
  };

  firstTimeTabToggle = true;
  removeDiscussionLocalStorageProject();
  Object.keys(boardDetails).forEach((key) => setDiscussionLocalStorage(key, boardDetails[key]));
  $discussionPanel.removeData('shoppableThread shoppableId');
  $discussionPanel.data('boardThread', boardThread);
  $discussionPanel.data('boardId', boardId);
  $boardHeader.find('.discussion-panel__board-link').attr('href', boardUrl);
  $boardHeader.find('.discussion-panel__shoppable-link').attr('href', '');
  $boardHeader.find('.discussion-panel__board-name').text(trimThreadViewTitle(boardName));
  setBoardImage($boardHeader, boardImage);
  $boardHeader.find('.discussion-panel__board-swatch').attr('style', '');
  updateBoardThreadId(boardThread, boardId);
  $discussionPanel.find('#message_messageable_type').val('');
  $discussionPanel.find('#message_messageable_id').val('');
  toggleBoardThreadDraftMode(boardThread, boardId, boardPublished);
  toggleDiscussionPanelThreadClass(boardThread);
  $messagesContainers.each(function () {
    updateMessagesContainer($(this), messageId);
  });
  toggleBoardThreadStatus();
}

function disableBoardThreadView(messageId = null) {
  const $boardHeader = $discussionPanel.find('.discussion-panel__thread-container');
  const $messagesContainers = $discussionPanel.find('.discussion-panel__messages-container');
  const $formBoardToggle = $discussionPanel.find('.discussion-panel__form-board-container');
  const pageBoardThread = $formBoardToggle.data('page-board-thread') || '';
  const pageBoardId = $formBoardToggle.data('page-board-id') || '';

  firstTimeTabToggle = true;
  removeDiscussionLocalStorageProject();
  $discussionPanel.removeData('boardThread boardId shoppableThread shoppableId');
  $boardHeader.find('.discussion-panel__board-link').attr('href', '');
  $boardHeader.find('.discussion-panel__shoppable-link').attr('href', '');
  $boardHeader.find('.discussion-panel__board-name').empty();
  setBoardImage($boardHeader, '');
  $boardHeader.find('.discussion-panel__board-swatch').attr('style', '');
  $discussionPanel
    .find('.discussion-panel__form-container')
    .removeClass('discussion-panel__form-container--draft');
  $discussionPanel.find('.file-uploader-drop').removeClass('file-uploader-drop--disabled');
  updateBoardThreadId(pageBoardThread, pageBoardId);
  $discussionPanel.find('#message_messageable_type').val('');
  $discussionPanel.find('#message_messageable_id').val('');
  toggleDiscussionPanelThreadClass();
  $messagesContainers.each(function () {
    updateMessagesContainer($(this), messageId);
  });
  toggleBoardThreadStatus();
}

function enableShoppableThreadView(
  shoppableThread,
  shoppableId,
  shoppableName,
  shoppableImage,
  shoppableUrl,
  messageableId,
  boardThread,
  boardId,
  boardName,
  boardImage,
  boardUrl,
  boardPublished,
  messageId = null
) {
  const $boardHeader = $discussionPanel.find('.discussion-panel__thread-container');
  const $messagesContainers = $discussionPanel.find('.discussion-panel__messages-container');
  const shoppableDetails = {
    'shoppable-thread': shoppableThread,
    'shoppable-id': shoppableId,
    'shoppable-name': shoppableName,
    'shoppable-image': shoppableImage,
    'shoppable-url': shoppableUrl,
    'messageable-id': messageableId,
    'board-thread': boardThread,
    'board-id': boardId,
    'board-name': boardName,
    'board-image': persistableBoardImage(boardImage),
    'board-url': boardUrl,
    'board-published': boardPublished,
  };

  firstTimeTabToggle = true;
  removeDiscussionLocalStorageProject();
  Object.keys(shoppableDetails).forEach((key) =>
    setDiscussionLocalStorage(key, shoppableDetails[key])
  );
  $discussionPanel.data('boardThread', boardThread);
  $discussionPanel.data('boardId', boardId);
  $discussionPanel.data('shoppableThread', shoppableThread);
  $discussionPanel.data('shoppableId', shoppableId);
  $boardHeader
    .find('.discussion-panel__shoppable-back-arrow')
    .data({ boardThread, boardId, boardName, boardImage, boardUrl, boardPublished });
  $boardHeader
    .find('.discussion-panel__shoppable-link')
    .attr('href', shoppableUrl)
    .attr('data-ui--twin-turbo-modal-trigger-title-value', shoppableName);
  $boardHeader.find('.discussion-panel__board-link').attr('href', '');
  $boardHeader.find('.discussion-panel__board-name').text(trimThreadViewTitle(shoppableName));

  if (shoppableThread === 'swatch') {
    $discussionPanel.addClass('discussion-panel--swatch');
    $boardHeader.find('.discussion-panel__board-swatch').attr('style', shoppableImage);
    setBoardImage($boardHeader, '');
  } else {
    setBoardImage($boardHeader, shoppableImage);
    $boardHeader.find('.discussion-panel__board-swatch').attr('style', '');
  }

  updateBoardThreadId(boardThread, boardId);
  const messageableType = getMessageableTypeFromShoppable(shoppableThread);
  $discussionPanel.find('#message_messageable_type').val(messageableType);
  $discussionPanel.find('#message_messageable_id').val(messageableId);
  toggleDiscussionPanelThreadClass(shoppableThread);
  $messagesContainers.each(function () {
    updateMessagesContainer($(this), messageId);
  });
}

function updateMessagesContainer($messagesContainer, messageId = null) {
  const $messages = $messagesContainer.find('.discussion-panel__messages');
  $messages.find('.discussion-message').each(function () {
    toggleMessageAuthorClass($(this));
    filterMessageByThread($(this));
  });
  divideMessagesContainerByDate($messagesContainer);
  loadMoreMessages($messagesContainer, null, true);

  if (messageId && $messagesContainer.hasClass('discussion-panel__messages-container--active')) {
    const $message = $messagesContainer.find(`.discussion-message[data-message-id="${messageId}"]`);
    $messagesContainer.scrollTop($message.position().top);
  } else {
    scrollToMessagesContainerEnd($messagesContainer);
  }
  updateDiscussionPanelContentHeight();
}

function toggleDiscussionPanelThreadClass(thread = null) {
  $discussionPanel.removeClass(
    'discussion-panel--board discussion-panel--shoppable discussion-panel--swatch'
  );

  if (thread === 'product' || thread === 'item') {
    $discussionPanel.addClass('discussion-panel--shoppable');
  } else if (thread === 'swatch') {
    $discussionPanel.addClass('discussion-panel--shoppable discussion-panel--swatch');
  } else if (thread === 'board' || thread === 'fp_board') {
    $discussionPanel.addClass('discussion-panel--board');
  }
}

function updateBoardThreadId(boardThread, boardId) {
  const $formBoardToggle = $discussionPanel.find('.discussion-panel__form-board-container');
  const focusInput = boardThread === 'fp_board' ? '#message_fp_board_id' : '#message_board_id';
  const blurInput = boardThread === 'fp_board' ? '#message_board_id' : '#message_fp_board_id';

  if ($formBoardToggle.length) {
    const $checkbox = $formBoardToggle.find(focusInput);

    if ($checkbox.length) {
      $checkbox.prop('checked', true);
    } else {
      $formBoardToggle.find('input[type="checkbox"]').prop('checked', false);
    }
  }

  $discussionPanel.find(focusInput).val(boardId);
  $discussionPanel.find(blurInput).val('');
}

function loadMoreMessages($container, targetMessageId = null, skipScroll = null) {
  const $messagesContainer = $container.find('.discussion-panel__messages');
  const $loadingSpinner = $('<div class="discussion-panel__loading">Loading...</div>');
  $container.find('.discussion-panel__empty').addClass('hide');
  $container.find('.discussion-panel__loading').remove();
  $messagesContainer.prepend($loadingSpinner);
  const currentPage = Number($container.data('currentPage')) || 0;
  const nextPage = currentPage + 1;
  $container.data('isLoading', true);

  $.ajax({
    url: `/discussions/projects/${panelProjectId}/messages`,
    data: {
      discussion_id: $container.data('discussion-id'),
      page: nextPage,
    },
    dataType: 'json',
    success(data) {
      if (data.html && data.html.trim() !== '') {
        const $tempContainer = $('<div>').html(data.html);
        const existingIds = new Set(
          $messagesContainer
            .find('.discussion-message')
            .map((_, el) => String($(el).data('messageId')))
            .get()
        );
        const messagesFragment = document.createDocumentFragment();
        const messageIds = [];
        $tempContainer.children().each((_, elem) => {
          const $message = $(elem);
          const messageId = $message.data('messageId');
          if (messageId !== undefined && messageId !== null && existingIds.has(String(messageId))) {
            return;
          }
          messagesFragment.appendChild(elem);
          messageIds.push(messageId);
        });

        $messagesContainer.prepend(messagesFragment);
        messageIds.forEach((id) => {
          if (window.requestIdleCallback) {
            requestIdleCallback(() => validateMessageBeforeShow(id));
          } else {
            setTimeout(() => validateMessageBeforeShow(id), 0);
          }
        });

        if (skipScroll) {
          scrollToMessagesContainerEnd($container);
        } else {
          const $firstMessage = $tempContainer.children().first();

          if ($firstMessage.length && $firstMessage.position()) {
            $container.scrollTop($firstMessage.position().top);
          }
        }

        $container.data('currentPage', nextPage);
      }
      $container.data('isLoading', false);
      $container.find('.discussion-panel__loading').remove();

      if (data.next_page === null) {
        $container.data('hasMorePages', false);
      }
      if (targetMessageId) {
        findMessageById($container, targetMessageId);
      } else {
        autoLoadForShortContainer($container);
      }
    },
    error() {
      $container.data('isLoading', false);
      $container.find('.discussion-panel__loading').remove();
      console.error('Unable to load more messages. Please try again.');
    },
  });
}

function autoLoadForShortContainer($container) {
  const containerHeight = $container.outerHeight();
  const messagesHeight = $container.find('.discussion-panel__messages').outerHeight();
  $container.data('autoLoadAttempts', ($container.data('autoLoadAttempts') || 0) + 1);
  if (
    $discussionPanel.hasClass('discussion-panel--active') &&
    messagesHeight <= containerHeight &&
    $container.data('hasMorePages') &&
    $container.data('autoLoadAttempts') < 50
  ) {
    loadMoreMessages($container, null, true);
  } else {
    $container.data('autoLoadAttempts', 0);
    toggleMessagesContainerEmptyAlert($container);
  }
}

function findMessageById($container, targetMessageId, threadView = null) {
  const $message = $container.find(`.discussion-message[data-message-id="${targetMessageId}"]`);
  const $panelLoadingSpinner = $container.find('.discussion-panel__loading--full-panel');
  const $messagesContainer = $container.find('.discussion-panel__messages');
  $container.data('findMessageAttempts', ($container.data('findMessageAttempts') || 0) + 1);

  if ($message.length) {
    const messageOffset = $message.position().top;
    $container.scrollTop(messageOffset);
    $message.addClass('discussion-message--highlighted');

    if (threadView) {
      if ($message.find('.discussion-message__shoppable-link').length) {
        $message.find('.discussion-message__shoppable-link').click();
      } else if ($message.find('.discussion-message__board-link').length) {
        $message.find('.discussion-message__board-link').click();
      }
    } else {
      disableBoardThreadView(targetMessageId);
    }

    setTimeout(function () {
      $message.removeClass('discussion-message--highlighted');
    }, 7000);

    if ($panelLoadingSpinner.length) {
      $panelLoadingSpinner.remove();
    }
    $messagesContainer.removeClass('discussion-panel__messages--loading');
    $container.data('findMessageAttempts', 0);
  } else {
    if ($container.data('hasMorePages') && $container.data('findMessageAttempts') < 50) {
      loadMoreMessages($container, targetMessageId, true);

      if (!$panelLoadingSpinner.length) {
        $messagesContainer.after(
          '<div class="discussion-panel__loading discussion-panel__loading--full-panel">Loading...</div>'
        );
      }
      $messagesContainer.addClass('discussion-panel__messages--loading');
    } else {
      console.error(`Unable to find message with id ${targetMessageId}`);

      if ($panelLoadingSpinner.length) {
        $panelLoadingSpinner.remove();
      }
      $messagesContainer.removeClass('discussion-panel__messages--loading');
    }
  }
}

function scrollToMessagesContainerEnd($messagesContainer, animateScroll = false) {
  // Some discussion panels (the shareable one) render without a messages container.
  if (!$messagesContainer.length) {
    return;
  }

  const scrollHeight = $messagesContainer[0].scrollHeight;

  if (animateScroll) {
    $messagesContainer.animate({ scrollTop: scrollHeight }, 400);
  } else {
    $messagesContainer.scrollTop(scrollHeight);
    setTimeout(function () {
      $messagesContainer.scrollTop(scrollHeight);
    }, 0);
  }

  $messagesContainer
    .find('.discussion-panel__present-container')
    .removeClass('discussion-panel__present-container--active');
}

function appendSendingStateMessage(formData) {
  const $messagesContainer = $discussionPanel.find('.discussion-panel__messages-container--active');
  const $messages = $messagesContainer.find('.discussion-panel__messages');
  const $sendingMessage = $discussionPanel.find('.discussion-panel__sending-message');
  const discussionKind = formData.get('discussion_kind');
  const textMessageValue = formData.get('message[text]');
  const boardIdValue = formData.get('message[board_id]');
  const fpBoardIdValue = formData.get('message[fp_board_id]');
  const attachmentsCount = formData.getAll('message[files][]').length;
  const boardId = boardIdValue || fpBoardIdValue;
  const thread = boardIdValue ? 'board' : 'fp_board';
  const messageableId = formData.get('message[messageable_id]');
  const shoppableThread = getShoppableFromMessageableType(
    formData.get('message[messageable_type]')
  );

  if (attachmentsCount > 0 && formData.get('message[files][]').size > 0) {
    const $attachmentContainer = $sendingMessage.find('.discussion-message__attachment');
    for (let i = 1; i < attachmentsCount; i++) {
      const $attachmentClone = $attachmentContainer.clone();
      $attachmentContainer.after($attachmentClone);
    }
    $sendingMessage.find('.discussion-message__attachment').removeClass('hide');
  }

  if (messageableId) {
    $sendingMessage.find('.discussion-message__shoppable').removeClass('hide');
    $sendingMessage
      .find('.discussion-message')
      .addClass('discussion-message--shoppable')
      .attr({ 'data-messageable-id': messageableId, 'data-shoppable-thread': shoppableThread });
  } else if (boardId) {
    $sendingMessage.find('.discussion-message__board').removeClass('hide');
    $sendingMessage
      .find('.discussion-message')
      .addClass('discussion-message--board')
      .attr({ 'data-board-id': boardId, 'data-board-thread': thread });
  }
  $sendingMessage.find('.discussion-message').attr('data-kind', discussionKind);

  if (!isBlankInput(textMessageValue)) {
    $sendingMessage.find('.discussion-message__message').html(textMessageValue);
    $sendingMessage.find('.discussion-message__message').removeClass('hide');
  }

  $messages.append($sendingMessage.html());
  toggleMessagesContainerEmptyAlert($messagesContainer);
  scrollToMessagesContainerEnd($messagesContainer);
}

function disableMessageInputs($form) {
  $form.find('button[type="submit"]').addClass('button-loading').attr('disabled', true);
  $form.find('.tiptap').addClass('text-editor--disabled').attr('contenteditable', 'false');
  $form.find('.t-button--attach-a-file').addClass('button-disabled').attr('disabled', true);
  $form.find('.file-preview-link').addClass('file-preview-link--disabled');
  $form.closest('.file-uploader-drop').addClass('file-uploader-drop--disabled');
}

function enableMessageInputs($form) {
  $form
    .find('button[type="submit"]')
    .removeClass('button-loading button-disabled')
    .attr('disabled', false);
  $form.find('.tiptap').removeClass('text-editor--disabled').attr('contenteditable', 'true');
  $form.find('.t-button--attach-a-file').removeClass('button-disabled').attr('disabled', false);
  $form.find('.file-preview-link').removeClass('file-preview-link--disabled');
  $form.closest('.file-uploader-drop').removeClass('file-uploader-drop--disabled');
}

function isBlankInput(input) {
  if (!input) {
    return true;
  }

  const isEmptyText = input.trim() === '';
  const isEmptyBlock = /^\s*<(p|h[1-6])>\s*\s*<\/(p|h[1-6])>\s*$/i;
  const isOnlyBreaks = /^\s*(<(p|h[1-6])>\s*(<br>\s*)*<\/(p|h[1-6])>\s*)+$/i;

  return isEmptyText || isEmptyBlock.test(input) || isOnlyBreaks.test(input);
}

function isMessageInputValid(messageInputValue) {
  const isBlank = isBlankInput(messageInputValue);

  if (!isBlank) {
    return true;
  }
}

function toggleMessageSubmitButton(target) {
  const $formContainer = $(target).closest('.discussion-panel__form-container');
  const $messageInputField = $formContainer.find('input[name="message[text]"]');
  const messageInputValue =
    $messageInputField.length > 0 && $messageInputField.val()
      ? $messageInputField.val().trim()
      : '';
  const imagePreviews = $formContainer.find('.file-preview-link');
  const hasImagePreviews = imagePreviews.length > 0;
  const $submitButton = $formContainer.find('button[type="submit"]');

  if (isMessageInputValid(messageInputValue) || hasImagePreviews) {
    $submitButton.removeClass('button-disabled').attr('disabled', false);
  } else {
    $submitButton.addClass('button-disabled').attr('disabled', true);
  }
}

function revealDiscussionMessages() {
  $discussionPanel
    .find('.discussion-message')
    .not('.discussion-message--sending')
    .each(function () {
      validateMessageBeforeShow($(this).data('messageId'));
    });
}

function toggleMessagesContainerEmptyAlert($messagesContainer) {
  const $messages = $messagesContainer.find('.discussion-message').not('.hide');
  const $emptyAlert = $messagesContainer.find('.discussion-panel__empty');

  if ($messages.length || $messagesContainer.data('autoLoadAttempts') > 0) {
    $emptyAlert.addClass('hide');
  } else {
    $emptyAlert.removeClass('hide');
  }
}

function openDiscussionPanelWithParams(messageId, team, threadView = null) {
  firstTimeTabToggle = false;

  if (team && $('.discussion-panel__messages-container--team').length) {
    toggleDiscussionTab('team');
  } else {
    toggleDiscussionTab('client');
  }

  if (messageId) {
    removeDiscussionLocalStorageProject();
    const $container = team
      ? $('.discussion-panel__messages-container--team')
      : $('.discussion-panel__messages-container--client');
    findMessageById($container, messageId, threadView);
  }
}

function updateDiscussionTooltipReadStatus() {
  if (pageUserRole === 'designer') {
    $.post('/users/xhr_set_preference', {
      key: 'hide_discussion_panel_alert',
      value: true,
    });
  } else if (pageUserRole === 'client') {
    $.post('/users/xhr_set_client_design_notifications_as_read', {
      projectId: panelProjectId,
    });
  }
}

// eslint-disable-next-line no-unused-vars
export function toggleDiscussionBoardDraft(boardThread, boardId, published) {
  const $formBoardToggle = $discussionPanel.find('.discussion-panel__form-board-container');
  if ($formBoardToggle.length) {
    $formBoardToggle.attr('data-page-board-published', published);
  }
  toggleBoardThreadStatus();
  toggleBoardThreadDraftMode(boardThread, boardId, published);
  const $messages = $discussionPanel.find(
    `.discussion-message[data-board-thread="${boardThread}"][data-board-id="${boardId}"]`
  );
  $messages.attr('data-board-published', published);
}

const messageableTypes = {
  swatch: 'BoardSwatch',
  product: 'BoardProduct',
  item: 'BoardItem',
};

function getMessageableTypeFromShoppable(type) {
  return messageableTypes[type];
}

function getShoppableFromMessageableType(className) {
  const typeToClassMap = Object.fromEntries(
    Object.entries(messageableTypes).map(([key, value]) => [value, key])
  );
  return typeToClassMap[className];
}

function trimThreadViewTitle(title, maxLength = 50) {
  return title.length > maxLength ? title.substring(0, maxLength - 3) + '...' : title;
}

function calcMainContainerPadding() {
  if (!shouldOffsetMainForDiscussionPanel()) {
    return;
  }

  const isPanelActive = $discussionPanel.hasClass('discussion-panel--active');
  const bodyId = document.body.id;
  const pageWidth = document.body.offsetWidth;

  if (pageWidth < 1600) {
    const $mainContainer = $('.main-container');
    const mainContainerElement = $mainContainer[0];

    if (mainContainerElement) {
      mainContainerElement.style.setProperty('--main-discussion-panel-padding', '0');
      const mainInnerElement = $mainContainer.querySelector('.main__inner');
      if (mainInnerElement) {
        mainInnerElement.style.setProperty('--main-discussion-panel-margin', '0');
      }
    }
    return;
  }

  if (isPanelActive) {
    if (['board', 'fp-boards-floorplan', 'boards-preview', 'fp-board-preview'].includes(bodyId)) {
      let mainPadding = 0;
      let mainMargin = 0;

      if ($mainContainer.hasClass('main--full-width')) {
        const mainInnerWidth = $('.main__inner').outerWidth();
        const panelWidth = $discussionPanel.outerWidth();

        mainPadding = 0;
        mainMargin = pageWidth - mainInnerWidth - panelWidth - 40;

        if (pageWidth > panelWidth * 2 + mainInnerWidth + 24) {
          mainMargin = 'auto';
        } else {
          mainMargin = `${mainMargin}px`;
        }
      } else {
        const marginRight = (pageWidth - $mainContainer[0].offsetWidth) / 2;
        const panelHalfWidth = $discussionPanel.outerWidth() / 2;
        const rawMargin = $discussionPanel[0].offsetWidth + 44 - marginRight;

        mainPadding = Math.max(0, rawMargin - panelHalfWidth);
        mainMargin =
          rawMargin > panelHalfWidth
            ? panelHalfWidth - mainPadding
            : Math.min(rawMargin, panelHalfWidth);
        mainPadding = `${mainPadding * 2}px`;
        mainMargin = `-${mainMargin}px`;
      }
      $mainContainer[0].style.setProperty('--main-discussion-panel-padding', mainPadding);
      $mainContainer
        .find('.main__inner')[0]
        .style.setProperty('--main-discussion-panel-margin', mainMargin);
    }
  }
}

function updateDiscussionPanelContentHeight() {
  let keyboardHeight = 0;
  if ($discussionPanel.hasClass('discussion-panel--active')) {
    if (isMobile()) {
      const visualViewportHeight = window.visualViewport.height;
      const windowHeight = window.innerHeight;
      keyboardHeight = Math.max(0, windowHeight - visualViewportHeight);

      document.documentElement.style.setProperty('--mobile-keyboard-height', `${keyboardHeight}px`);
      document.documentElement.style.setProperty(
        '--discussion-panel-translate-y',
        `-${keyboardHeight}px`
      );
      $discussionPanel.toggleClass('discussion-panel--keyboard-open', keyboardHeight > 0);

      if ($(window).scrollTop() === 0) {
        window.scrollTo({ top: 1 });
      }
    } else {
      document.documentElement.style.setProperty('--mobile-keyboard-height', '0px');
      document.documentElement.style.setProperty('--discussion-panel-translate-y', '0px');
    }
  }

  const keyboardOpen = isMobile() && keyboardHeight > 0;
  let totalHeaderHeight = 0;
  const header = $('.header');
  if (header.length && !keyboardOpen) {
    totalHeaderHeight += header.outerHeight();
  }
  const discussionPanelHeader = $('.discussion-panel__header');
  if (discussionPanelHeader.length) {
    totalHeaderHeight += discussionPanelHeader.outerHeight();
  }
  const tabsContainer = $('.discussion-panel__tabs-container');
  if (tabsContainer.length && tabsContainer.is(':visible')) {
    totalHeaderHeight += tabsContainer.outerHeight();
  }
  const recipients = $('.discussion-panel__recipients');
  if (recipients.length && recipients.is(':visible')) {
    totalHeaderHeight += recipients.outerHeight();
  }
  const previewBand = $('.preview-band');
  if (previewBand.length && !keyboardOpen) {
    totalHeaderHeight += previewBand.outerHeight();
  }
  totalHeaderHeight += keyboardOpen ? 8 : 18;
  const threadContainer = $('.discussion-panel__thread-container');
  if (threadContainer.is(':visible')) {
    totalHeaderHeight += threadContainer.outerHeight();
  }
  const $discussionPanelContent = $('.discussion-panel__content')[0];
  if ($discussionPanelContent) {
    $discussionPanelContent.style.setProperty(
      '--discussion-panel-header-height',
      `${totalHeaderHeight}px`
    );
  }
}

onPageLoad(() => {
  $discussionPanel = $('.discussion-panel').first();
  $mainContainer = $discussionPanel.closest('.main');
  panelProjectId = $discussionPanel.attr('data-project-id');
  pageUserRole = $('body').attr('data-role');
  firstTimeTabToggle = true;

  $(document).on('click', '.dropdown-menu__link--edit-message', function (e) {
    e.preventDefault();

    const $messageWrapper = $(this).closest('.discussion-message');
    const messageId = String($messageWrapper.data('message-id'));
    const $form = $discussionPanel.find('.tiptap').closest('form');

    if ($form.find('#update_message_id').val() === messageId) {
      return;
    }

    $form.find('.file-preview-link').remove();

    if ($messageWrapper.find('.discussion-message__attachment').length) {
      $messageWrapper.find('.discussion-message__attachment').each((_i, attachment) => {
        const $attachment = $(attachment);
        const $image = $attachment.find('.discussion-message__attachment-image');
        const attachmentImageSrc = $image.length ? $image.attr('src') : null;
        const attachmentId = $attachment.data('attachment-item-id');
        const $fileContainer = $form.find('.js-file-preview--discussion-message');

        if (!attachmentId || !$fileContainer.length) {
          return;
        }

        const $preview = $(`
        <span class="file-preview-link file-preview-link--existing" data-file-index="${attachmentId}">
          ${
            attachmentImageSrc
              ? `<img class="file-attached-thumb" src="${attachmentImageSrc}"/>`
              : '<span class="file-attached-thumb"><i class="fa-light fa-file" aria-hidden="true"></i></span>'
          }
          <span class="file-preview-remove"><i class="fa-regular fa-xmark" aria-hidden="true"></i></span>
        </span>
      `);

        $fileContainer.append($preview);
      });
    }

    $form.find('button[type="submit"]').removeClass('button-disabled').attr('disabled', false);

    const $text = $messageWrapper.find('.discussion-message__text');
    const $messageContent = $text.length
      ? $text
      : $messageWrapper.find('.discussion-message__message');
    if ($messageContent.length) {
      const messageContent = $messageContent.html().trim();
      const $input = $discussionPanel.find('.tiptap');

      $input.attr('data-js-update-content', messageContent);
      $input.focus();
    }

    $form
      .closest('.discussion-panel__form-container')
      .addClass('discussion-panel__form-container--editing');
    $form.find('#update_message_id').val(messageId);
    const $messageAttachments = $messageWrapper.find('.discussion-message__attachment');
    const $itemIdsInput = $form.find('input[name="user_file_ids"]');
    $itemIdsInput.val('');
    $messageAttachments.each((_i, attachment) => {
      const attachmentItemId = $(attachment).data('attachment-item-id');
      if (attachmentItemId) {
        const currentVal = $itemIdsInput.val();
        const newVal = currentVal ? `${currentVal},${attachmentItemId}` : attachmentItemId;
        $itemIdsInput.val(newVal).trigger('change');
      }
    });
  });

  $(document).on(
    'click',
    '.discussion-panel__form-container--editing .t-button--cancel-message-edit',
    function (e) {
      e.preventDefault();
      const $form = $(this).closest('form');
      $form
        .closest('.discussion-panel__form-container')
        .removeClass('discussion-panel__form-container--editing');
      resetMessageInputs($form);
    }
  );

  $(document).on(
    'click',
    '.discussion-panel__form-container--editing .p-button--update-message',
    function (e) {
      e.preventDefault();

      const $form = $(this).closest('form');
      const $input = $form.find('input[name="message[text]"]');
      const messageContent = ($input.val() || '').trim();
      const messageId = $form.find('#update_message_id').val();

      if (!messageId) {
        console.error('Could not find message ID');
        return;
      }

      $form.find('button[type="submit"]').addClass('button-disabled').attr('disabled', true);

      const formData = new FormData();
      formData.append('message[text]', isBlankInput(messageContent) ? '' : messageContent);
      formData.append('discussion_kind', $form.find('#discussion_kind').val());

      const $fileUploadField = $form.find('.file-uploader-field--discussion-message');
      const fileUploadValue =
        $fileUploadField.length > 0 && $fileUploadField.val() ? $fileUploadField.val().trim() : '';

      if (fileUploadValue) {
        const imageFiles = $fileUploadField.data().files;
        const imageElementName = $fileUploadField.attr('name');
        formData.delete(imageElementName);
        if (imageFiles) {
          imageFiles.forEach((file) => {
            formData.append(imageElementName, file, file.name);
          });
        }
      }

      const userFileIds = $('input[name="user_file_ids"]').val();
      const originController = $('input[name="origin_controller"]').val();
      const originAction = $('input[name="origin_action"]').val();

      if (userFileIds) {
        const userFileIdsArray = userFileIds.split(',').map((id) => id.trim());
        userFileIdsArray.forEach((id) => {
          formData.append('user_file_ids[]', id);
        });
      }
      if (originController) {
        formData.append('origin_controller', originController);
      }
      if (originAction) {
        formData.append('origin_action', originAction);
      }

      $.ajax({
        url: `/messages/${messageId}`,
        type: 'PATCH',
        data: formData,
        processData: false,
        contentType: false,
      })
        .done((data) => {
          resetMessageInputs($form);
        })
        .fail((error) => {
          console.error('Error updating message:', error);
          $form
            .find('button[type="submit"]')
            .removeClass('button-disabled')
            .attr('disabled', false);
        });
    }
  );

  $(document).on('click', '.dropdown-menu__link--delete-message', function (e) {
    e.preventDefault();

    const deleteUrl = $(this).data('deleteUrl');
    const $message = $(this).closest('.discussion-message');

    $('#modal--delete-message').modal();
    $('#modal--delete-message .d-button--confirm-delete-message')
      .off('click')
      .on('click', function (e) {
        e.preventDefault();

        $.ajax({
          url: deleteUrl,
          type: 'DELETE',
          success(data) {
            deleteMessage($message.data('messageId'));
            $.modal.close();
          },
          error(data) {
            console.error('Unable to delete the message. Please try again.');
          },
        });

        return false;
      });

    return false;
  });

  $(document).on('click', '.dropdown-menu__link--copy-message-link', function (e) {
    e.preventDefault();
    const $message = $(this).closest('.discussion-message');
    const messageId = $message.data('message-id');
    const currentBaseUrl = window.location.origin;
    let messageLink = `${currentBaseUrl}/projects/${panelProjectId}/boards?discussion=true&message=${messageId}`;

    if (
      $(this).closest('.discussion-panel__messages-container').data('discussions-tab-messages') ===
      'team'
    ) {
      messageLink = `${currentBaseUrl}/projects/${panelProjectId}/boards?discussion=true&message=${messageId}&team=true`;
    }

    navigator.clipboard.writeText(messageLink).catch((err) => {
      console.error('Unable to copy link. Please try again.');
    });
  });

  $(document).on(
    'click',
    '.discussion-panel__header, [data-discussion-panel-toggle]',
    function (e) {
      const shareableLoginLink = document.querySelector('nav .login-required');

      if ($discussionPanel.hasClass('discussion-panel--shareable') && shareableLoginLink) {
        shareableLoginLink.click();
      } else {
        toggleDiscussionPanel(null, false, false, false, true);
      }
    }
  );

  $(document).on(
    'click',
    '.h-s-button--open-discussion-panel, .sidebar-notification__link--open-discussion-panel, .user-file-link--open-discussion-panel, .action-badge--open-discussion-panel',
    function (e) {
      if ($discussionPanel.length > 0) {
        const href = $(this).attr('href');

        if (href) {
          const [hrefPath, hrefQuery] = href.split('?');

          // Allow for URL without project-id for these classes
          if (!$(this).hasClass('action-badge--open-discussion-panel')) {
            const pathSegments = hrefPath.split('/');
            const hrefProjectId = pathSegments[2];

            if (panelProjectId !== hrefProjectId) {
              return;
            }
          }

          e.preventDefault();
          e.stopPropagation();
          toggleDiscussionPanel(true, false, true, false, false);

          if (hrefQuery) {
            const params = new URLSearchParams(hrefQuery);
            const discussionParam = params.get('discussion');
            const messageIdParam = params.get('message');
            const teamParam = params.get('team');
            const openThreadParam = params.get('thread');

            if (discussionParam === 'true') {
              openDiscussionPanelWithParams(messageIdParam, teamParam, openThreadParam);
            }
          }
        }
      }
    }
  );

  $(document).on('click', '.discussion-panel__tab', function () {
    const selectedTab = $(this).data('discussions-tab');
    toggleDiscussionTab(selectedTab);
  });

  document.addEventListener('turbo:before-stream-render', (event) => {
    if (event.detail.newStream.getAttribute('target') !== 'discussion-panel-client-content') {
      return;
    }

    const originalRender = event.detail.render;
    event.detail.render = function (streamElement) {
      originalRender(streamElement);
      revealDiscussionMessages();
    };
  });

  document.addEventListener('turbo:before-stream-render', (event) => {
    if (event.detail.newStream.getAttribute('target') !== 'discussion-panel-form-container') {
      return;
    }

    const originalRender = event.detail.render;
    event.detail.render = function (streamElement) {
      originalRender(streamElement);
      const activeTab =
        $discussionPanel.find('.discussion-panel__tab--active').data('discussions-tab') || 'client';
      toggleDiscussionTab(activeTab);
    };
  });

  $(document).on('dataChange', '.file-uploader-field--discussion-message', (e) => {
    toggleMessageSubmitButton(e.target);
  });

  $(document).on('input keyup', '.discussion-panel__form-container .tiptap', function () {
    toggleMessageSubmitButton(this);
  });

  // Tiptap's serializer dispatches an `input` event on the hidden field after
  // every content update (typing, paste, undo, etc.).  Listening here guarantees
  // the hidden field already contains the serialized HTML, which makes this the
  // reliable path for enabling the submit button — especially for right-click
  // paste, where the contenteditable doesn't fire its own `input` or `keyup`.
  $(document).on(
    'input',
    '.discussion-panel__form-container input[name="message[text]"]',
    function () {
      toggleMessageSubmitButton(this);
    }
  );

  $(document).on('keydown', '.discussion-panel__form-container .tiptap', function (e) {
    if ((e.metaKey || e.ctrlKey) && e.key === 'Enter') {
      const $form = $(e.target).closest('form');
      const $hiddenField = $form.find('input[name="message[text]"]');
      const value = ($hiddenField.val() || '').trim();

      if (isMessageInputValid(value)) {
        const $submitButton = $form.find('button[type="submit"]:not([disabled])');
        if ($submitButton.length) {
          e.preventDefault();
          $submitButton.trigger('click');
        }
      }
    }
  });

  $(document).on(
    'change',
    'input[name="user_file_ids"], .discussion-panel__form-container .file-uploader-field--discussion-message',
    function (e) {
      toggleMessageSubmitButton(e.target);
    }
  );

  $(document).on('submit', '.discussion-panel__form-container form', function (e) {
    const $form = $(e.target);
    const $submitButton = $form.find('button[type="submit"]:visible');

    if ($submitButton.hasClass('button-disabled') || $submitButton.is(':disabled')) {
      e.preventDefault();
      return;
    }

    $submitButton.addClass('button-disabled').attr('disabled', true);
    disableMessageInputs($form);

    const formData = new FormData(e.target);
    const $fileUploadField = $form.find('.file-uploader-field--discussion-message');
    const fileUploadValue =
      $fileUploadField.length > 0 && $fileUploadField.val() ? $fileUploadField.val().trim() : '';

    if (fileUploadValue) {
      e.preventDefault();
      const imageFiles = $fileUploadField.data().files;
      const imageElementName = $fileUploadField.attr('name');
      formData.delete(imageElementName);
      if (imageFiles) {
        imageFiles.forEach((file) => {
          formData.append(imageElementName, file, file.name);
        });
      }
      appendSendingStateMessage(formData);

      const messageText = formData.get('message[text]');
      if (isBlankInput(messageText)) {
        formData.set('message[text]', '');
      }

      $.ajax({
        url: $form.attr('action'),
        type: 'POST',
        data: formData,
        processData: false,
        contentType: false,
      })
        .done((data) => {
          resetMessageInputs($form);
        })
        .fail((error) => {
          console.error(error);
          enableMessageInputs($form);
        });
    } else {
      resetMessageInputs($form);
      appendSendingStateMessage(formData);
    }
  });

  $(document).on('click', '.discussion-message__board-link', function (e) {
    if ($(this).hasClass('discussion-message__board-link--submitted')) {
      // Only return for genuine user clicks, not programmatic jQuery .click() triggers
      if (e.originalEvent) {
        return;
      }
    }

    e.preventDefault();
    const $discussionMessage = $(this).closest('.discussion-message');
    enableBoardThreadView(
      $discussionMessage.data('board-thread'),
      $discussionMessage.data('board-id'),
      $discussionMessage.data('board-name'),
      messageBoardImage($discussionMessage),
      $discussionMessage.data('board-url'),
      $discussionMessage.data('board-published'),
      $discussionMessage.data('message-id')
    );
  });

  $(document).on('click', '.discussion-message__shoppable-link', function (e) {
    e.preventDefault();
    const $discussionMessage = $(this).closest('.discussion-message');
    enableShoppableThreadView(
      $discussionMessage.data('shoppable-thread'),
      $discussionMessage.data('shoppable-id'),
      $discussionMessage.data('shoppable-name'),
      $discussionMessage.data('shoppable-image'),
      $discussionMessage.data('shoppable-url'),
      $discussionMessage.data('messageable-id'),
      $discussionMessage.data('board-thread'),
      $discussionMessage.data('board-id'),
      $discussionMessage.data('board-name'),
      messageBoardImage($discussionMessage),
      $discussionMessage.data('board-url'),
      $discussionMessage.data('board-published'),
      $discussionMessage.data('message-id')
    );
  });

  $(document).on('click', '.discussion-panel__board-back-arrow', function (e) {
    disableBoardThreadView();
  });

  $(document).on('click', '.discussion-panel__shoppable-back-arrow', function (e) {
    enableBoardThreadView(
      $(this).data('boardThread'),
      $(this).data('boardId'),
      $(this).data('boardName'),
      $(this).data('boardImage'),
      $(this).data('boardUrl'),
      $(this).data('boardPublished')
    );
  });

  $(document).on('click', '.tooltip__close--discussion-panel', function (e) {
    updateDiscussionTooltipReadStatus();
  });

  $(document).on('click', '.discussion-panel__present', function (e) {
    const $messagesContainer = $(this).closest('.discussion-panel__messages-container');
    scrollToMessagesContainerEnd($messagesContainer, true);
  });

  $(document).on(
    'click',
    '.discussion-panel__flash-link, .s-button--board-open-discussion-panel',
    function (e) {
      e.preventDefault();
      const $formBoard = $discussionPanel.find('.discussion-panel__form-board-container');
      enableBoardThreadView(
        $formBoard.data('page-board-thread'),
        $formBoard.data('page-board-id'),
        $formBoard.find('.discussion-panel__form-board-name').text(),
        $formBoard.find('[data-board-image-template]').get(0),
        $formBoard.data('page-board-url'),
        $formBoard.data('page-board-published')
      );
      toggleDiscussionPanel(true, false, false, true, false);
    }
  );

  $(document).on('click', '.shoppable-open-discussion-button', function (e) {
    const $shoppable = $(this).closest('li.shoppable');
    const shoppableThread = $shoppable.data('kind');
    const shoppableImage =
      shoppableThread === 'swatch'
        ? $shoppable.find('.shoppable__swatch').attr('style')
        : $shoppable.find('.shoppable__image').attr('src');

    enableShoppableThreadView(
      shoppableThread,
      $shoppable.data('id'),
      $shoppable.data('name'),
      shoppableImage,
      $shoppable.data('url'),
      $shoppable.data('board-shoppable-id'),
      'board',
      $('meta[name="board-id"]').attr('content'),
      $('meta[name="board-name"]').attr('content'),
      document.querySelector('[data-board-image-template]'),
      $('meta[name="board-url"]').attr('content'),
      $('meta[name="board-published"]').attr('content')
    );
    toggleDiscussionPanel(true, false, false, true, false);
  });

  $('.discussion-panel__messages-container').each(function () {
    const $container = $(this);
    $container.data({
      currentPage: 1,
      isLoading: false,
      hasMorePages: true,
    });

    $container.on('scroll', function () {
      const distanceFromBottom =
        $container.prop('scrollHeight') - $container.scrollTop() - $container.outerHeight();

      if (
        $container.scrollTop() <= 8 &&
        !$container.data('isLoading') &&
        $container.data('hasMorePages')
      ) {
        loadMoreMessages($container);
      }

      $container
        .find('.discussion-panel__present-container')
        .toggleClass('discussion-panel__present-container--active', distanceFromBottom > 80);
    });
  });

  window.addEventListener('resize', () => {
    calcMainContainerPadding();
    updateDiscussionPanelContentHeight();
  });

  if (isMobile()) {
    window.visualViewport.addEventListener('resize', updateDiscussionPanelContentHeight);
    window.visualViewport.addEventListener('scroll', updateDiscussionPanelContentHeight);
  }

  $(document).ready(() => {
    if (!$discussionPanel.length) {
      return;
    }

    if ($discussionPanel.hasClass('discussion-panel--shareable')) {
      return;
    }

    revealDiscussionMessages();

    checkAndResetDiscussionLocalStorage();

    if (
      getDiscussionLocalStorageItem('status') === 'open' ||
      getDiscussionUrlParam('discussion') === 'true'
    ) {
      if (getDiscussionUrlParam('message')) {
        toggleDiscussionPanel(true, true, true, false, false);
        const teamParam = getDiscussionUrlParam('team') === 'true';
        const messageIdParam = getDiscussionUrlParam('message');
        openDiscussionPanelWithParams(messageIdParam, teamParam);
      } else {
        toggleDiscussionPanel(true, true, false, false, false);
      }
    }

    if (localStorage.getItem('discussionPanel') !== null) {
      if (
        ['product', 'item', 'swatch'].includes(getDiscussionLocalStorageItem('shoppable-thread'))
      ) {
        const shoppableKeys = [
          'shoppable-thread',
          'shoppable-id',
          'shoppable-name',
          'shoppable-image',
          'shoppable-url',
          'messageable-id',
          'board-thread',
          'board-id',
          'board-name',
          'board-image',
          'board-url',
          'board-published',
        ];
        const shoppableDetails = shoppableKeys.map((key) => getDiscussionLocalStorageItem(key));
        enableShoppableThreadView(...shoppableDetails);
      } else if (['board', 'fp_board'].includes(getDiscussionLocalStorageItem('board-thread'))) {
        const boardKeys = [
          'board-thread',
          'board-id',
          'board-name',
          'board-image',
          'board-url',
          'board-published',
        ];
        const boardDetails = boardKeys.map((key) => getDiscussionLocalStorageItem(key));
        enableBoardThreadView(...boardDetails);
      } else {
        disableBoardThreadView();
      }
    } else {
      disableBoardThreadView();
    }

    // Focus on the text editor when the discussion panel is opened
    const classObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const classes = $(mutation.target).prop(mutation.attributeName);
        if (classes.includes('discussion-panel--active')) {
          $discussionPanel.find('.tiptap').focus();
        }
      });
    });
    classObserver.observe($discussionPanel[0], {
      attributes: true,
      attributeFilter: ['class'],
    });
  });
});
